module.exports = __webpack_public_path__ + "img/logo-soc-nuevo.fb063d7d.png";